module.exports = __webpack_public_path__ + "static/media/Régua_Turma_Autofinanciada_Colorida_Fundo_Branco.fae4e3cd.jpg";